"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Account = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var AccountForm_1 = __importDefault(require("./AccountForm"));
var AccountDelete_1 = __importDefault(require("./AccountDelete"));
var AccountUpdate_1 = __importDefault(require("./AccountUpdate"));
var ModalPhase;
(function (ModalPhase) {
    ModalPhase[ModalPhase["CLOSE"] = 0] = "CLOSE";
    ModalPhase[ModalPhase["DELAYED_CLOSE"] = 1] = "DELAYED_CLOSE";
    ModalPhase[ModalPhase["OPEN"] = 2] = "OPEN";
})(ModalPhase || (ModalPhase = {}));
var Account = function (_a) {
    var onAccountDelete = _a.onAccountDelete;
    var _b = (0, react_1.useState)(ModalPhase.CLOSE), modalPhase = _b[0], setModalPhase = _b[1];
    var _c = (0, react_1.useState)(false), isDeleteAccountDelete = _c[0], setIsDeleteAccountDelete = _c[1];
    (0, react_1.useEffect)(function () {
        if (modalPhase === ModalPhase.DELAYED_CLOSE) {
            var timeout_1 = setTimeout(function () {
                setModalPhase(ModalPhase.CLOSE);
            }, 4000);
            return function () { return clearTimeout(timeout_1); };
        }
    }, [modalPhase]);
    return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [!isDeleteAccountDelete ?
                ((0, jsx_runtime_1.jsx)(AccountForm_1.default, { onDelete: function () { return setIsDeleteAccountDelete(true); }, onSubmit: function () { return setModalPhase(ModalPhase.OPEN); } }, void 0)) :
                ((0, jsx_runtime_1.jsx)(AccountDelete_1.default, { onSubmit: onAccountDelete, onCancel: function () { return setIsDeleteAccountDelete(false); } }, void 0)), (0, jsx_runtime_1.jsx)(AccountUpdate_1.default, { onCancel: function () { return setModalPhase(ModalPhase.CLOSE); }, onSubmit: function () { return setModalPhase(ModalPhase.DELAYED_CLOSE); }, isOpen: modalPhase === ModalPhase.OPEN || modalPhase === ModalPhase.DELAYED_CLOSE }, void 0)] }, void 0);
};
exports.Account = Account;
exports.default = exports.Account;
